/* eslint-disable */
import React from 'react';

const AccessControlIcon = props => (
  <svg
    width="42"
    height="42"
    fill="none"
    {...props}
  >
    <circle cx="20.27" cy="14.33" r="6.38" stroke="#5B5D6E" strokeWidth="1.9" />
    <mask id="a" fill="#fff">
      <rect width="20.53" height="19.07" x="10" y="14.82" rx=".76" />
    </mask>
    <rect width="20.53" height="19.07" x="10" y="14.82" stroke="#5B5D6E" strokeWidth="4.4" mask="url(#a)" rx=".76" />
    <path fill="#FF8354" d="M11.96 16.78h16.62v15.16H11.96z" />
    <path fill="#545454" d="M19.05 22.65h2.44v4.89h-2.44z" />
    <circle cx="20.27" cy="23.13" r="1.96" fill="#545454" />
    <path fill="#FFA685" d="M11.96 16.78h1.47v15.16h-1.47z" />
    <circle cx="28.93" cy="32.78" r="5.09" fill="#fff" />
    <circle cx="29" cy="32.84" r="4.7" fill="#1FC09A" />
    <path fill="#fff" d="m31.06 31.4-2.7 2.67-.22-.16-.78-.8 1 1.02 2.7-2.73Zm0-.68-2.7 2.73-1-1.01-1 1.02 2 2.03 3.71-3.75-1-1.02Z" />
  </svg>
);

export default AccessControlIcon;
/* eslint-enable */
